export function formatDuration(minutes: number): string {
  const hours = Math.floor(minutes / 60)
  const remainingMinutes = minutes % 60
  return `${hours}:${String(remainingMinutes).padStart(2, '0')}`
}

// Rounds from whole minutes in integer tenths, so 5:15 reliably becomes 5,3 instead of drifting
// with floating-point hours. Uses the German decimal comma shown throughout the interface.
export function formatDecimalHours(minutes: number): string {
  const sign = minutes < 0 ? '-' : ''
  const tenths = Math.round((Math.abs(minutes) * 10) / 60)
  return `${sign}${Math.floor(tenths / 10)},${tenths % 10}`
}
